var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-col',{class:_vm.colClasses,attrs:{"lg":"12"}},[_c('p',{staticClass:"mb-0 fs-08"},[_c('b',[_vm._v(_vm._s(_vm.basePrice.value?.replace("EURO", "€")))])]),_vm._v(" "),_c('p',{staticClass:"fs-08 text-gray mt--1 mb-0"},[_vm._v(_vm._s(_vm.basePrice.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }